import * as types from "./mutationTypes";

export default {
  [types.SET_FEATURES](state, features) {
    state.features = features;
  },
  [types.CLEAR_FEATURES](state) {
    state.features = null;
  }
};
